import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { Observable } from "rxjs";

import { AuthService } from "services/auth.service";
import { DomainService } from "services/domain.service";

@Injectable({
  providedIn: "root",
})
export class LoginRequiredGuard implements CanActivate {
  currentUrl: string = "";

  constructor(
    private router: Router,
    private authService: AuthService,
    private _domainService: DomainService
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (this.authService.currentUserValue) {
      const referenceUrl = state.url || window.location.pathname;
      const allowedUrls = this._domainService.getAllowedUrls() || [];

      this.currentUrl = this.normalizeUrl(referenceUrl);
      const regex = /\b[a-f\d-]{36}\b/;
      const hasGuid = regex.test(this.currentUrl);
      if (hasGuid) {
        this.currentUrl = this.currentUrl.replace(regex, "");
        this.currentUrl = this.currentUrl.substring(
          0,
          this.currentUrl.length - 1
        );
      }

      if (this.authService.isOutsourcedLiableUser) {
        return true;
      }

      const allowByTargetUrl = this.checkUrl(allowedUrls, referenceUrl);
      const allowByCurrentPage = this.checkUrl(allowedUrls, window.location.pathname);

      if (!allowByTargetUrl && !allowByCurrentPage) {
        if (
          referenceUrl.includes("auth/login") ||
          referenceUrl.includes("home")
        ) {
          return true;
        }
        return false;
      }
      return true;
    } else {
      let domainName = this.authService.getDomainName();
      if (route.parent) {
        domainName = route.parent.params.domainName || domainName;
      }
      const authRoute = this.router.createUrlTree(
        [domainName, "auth", "login"],
        { queryParams: { returnUrl: state.url } }
      );

      return authRoute;
    }
  }

  checkUrl(allowedUrls: string[] = [], referenceUrl?: string) {
    if (this.checkMockedUrls()) {
      return true;
    }

    if (!allowedUrls?.length) {
      return false;
    }

    const normalizedReferenceUrl = this.normalizeUrl(referenceUrl || this.currentUrl);

    let checkPass = false,
      index = 0;
    while (checkPass === false && index < allowedUrls.length) {
      const normalizedAllowedUrl = this.normalizeUrl(allowedUrls[index]);
      if (normalizedReferenceUrl.includes(normalizedAllowedUrl)) checkPass = true;

      index++;
    }

    return checkPass;
  }

  checkMockedUrls() {
    const paths = [
      "corporate/benefit",
      "documents-management",
      "corporate/probationary-period",
      "corporate/self-employed-recess",
    ];

    const isMocked = paths.some((path) => window.location.href.includes(path));

    return isMocked;
  }

  private normalizeUrl(url: string): string {
    if (!url) {
      return "";
    }

    const withoutHash = url.split("#")[0];
    const withoutQuery = withoutHash.split("?")[0];
    const withoutLeadingSlash = withoutQuery.replace(/^\/+/, "");
    const withoutTrailingSlash = withoutLeadingSlash.replace(/\/+$/, "");

    return decodeURIComponent(withoutTrailingSlash).toLowerCase();
  }
}
